﻿import {String} from "./Misc.js"
import {Config} from "../config/Config.js";
    export class Delegate {
        // Modifier le paramètre => ... arg: array<any> => ...arg: any
        // Intégration d'un type générique ?
        #_items: Array<(...arg: any) => void>;

        constructor() {
            this.#_items = new Array<(...arg: any) => void>();
        }

        public Bind = (callBack: (...arg: any) => void, eventKey?: string) => {

            if (!String.IsNullOrEmpty(eventKey)) {
                this.Clear(eventKey);
                callBack["EventKey"] = eventKey;
            }

            this.#_items.push(callBack)
        };

        public Clear = async (key?: string) => {
            if (String.IsNullOrEmpty(key)) {
                this.#_items = new Array<(...arg: any) => void>();
                return;
            }

            this.#_items = this.#_items.filter(x => x["EventKey"] != key);

        }

        public Fire = (...arg: any) => {
            this.#_items.forEach(async (x) => {
                if (Config.Environment == "Development")
                    console.log("Event : " + x["EventKey"] + " - " + x.toString());

                x(...arg);
            });
        };

        public HasEvents = () => this.#_items.length > 0;

        public Length = () => this.#_items.length;
    }